import { render, staticRenderFns } from "./SelectInstitution.vue?vue&type=template&id=27555548&"
import script from "./SelectInstitution.vue?vue&type=script&lang=js&"
export * from "./SelectInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports